<!-- Component to show:
    Sensor Messages - Default
    Sensor Message details - Optional

  Props:
      1. rowsPerPage: Number of rows that must be shown on each page.
      2. items: Sensor message list that is going to be shown on table.
      3. fields: Fields that are visible for sensor messages
      4. busy: Flag to show loading icon on Sensor Message List table
      5. sensor: Sensor object related to this messages.
      6. showBackButton: Indicates if back button must be shown
      7. fieldsMsgsDetails: Visible fields for sensor message details

-->
<template>

  <div v-if="showMessageList">
    <b-container fluid>
      <p class="title-detail">Sensor Message History ({{ sensor.name }})</p>
      <div class="text-right mr-3 mb-3">
        <b-link v-if="showBackButton" @click="$emit('fnShowSensorList', true)"> Back </b-link>
      </div>
      <b-table striped
               show-empty
               :busy="busy"
               :items="items"
               :fields="fields"
               :current-page="pagination.current_page"
               :per-page="rowsPerPage">

        <template v-slot:cell(sampleDateTime)="item">
          {{ item.item.sampleDateTime | formatDateTimeTZ(user_timezone) }}

          
        </template>

        <template v-slot:cell(detail)="item">
          <b-link @click="displayMessageDetail(item.item)"> See More </b-link>
        </template>

        <template slot="table-busy">
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong style="margin-left:20px">Loading...</strong>
          </div>
        </template>
      </b-table>
      <b-row v-if="items && items.length > rowsPerPage">
        <b-col>
          <b-pagination v-model="pagination.current_page"
                        :total-rows="items ? items.length : 0"
                        :per-page="rowsPerPage"
                        align="center">
          </b-pagination>
        </b-col>
      </b-row>

    </b-container>
  </div>


  <div v-else>
    <k-Sensor-msg-details :sensor="sensor"
                          :fields="fieldsMsgsDetails"
                          :message="messageSelected"
                          :show-back-button="true"
                          @fnShowMessageList="fnShowMessageList" />
  </div>



</template>

<script>
  import KSensorMsgDetails from './SensorMsgDetails'
  import { get_user_timezone} from '../helpers/roles'


  export default {

    name: 'k-sensor-msg-list',

    components: { KSensorMsgDetails },

    props: {
      rowsPerPage: { type: Number, default: 20, required: false },

      items: { type: Array, default: [], required: true },
      fields: { type: Array, default: [], required: true },
      busy: { type: Boolean, default: false, required: true },
      sensor: { type: Object, required: true },
      showBackButton: { type: Boolean, default: false, required: false },

      fieldsMsgsDetails: { type: Array, default: [], required: false },
    },

    data() {

      return {
        showMessageList: true,

        messageSelected: null,

        pagination: {
          current_page: 1
        },
        user_timezone: null,
      }

    },

    mounted() { 
      this.user_timezone = get_user_timezone();
    },

    methods: {

      displayMessageDetail(message) {
        this.showMessageList = false;
        this.messageSelected = message;

        if (window.pageYOffset > 250) {
          window.scrollTo({ top: 250 });
        }

      },

      fnShowMessageList(show) {
        this.showMessageList = show;
      }

    }

  }

</script>

<style scoped>
  .title-detail {
    margin-bottom: -24px;
    left: 0px;
    right: 0px;
    font-weight: bold;
  }
</style>
